export const MAX_RECENT_TABS = 12;
